import { useAppDispatch, useAppSelector } from '@/hooks/store'
import { timeScheduleSlice } from '@/store/timeScheduleSlice'
import { SelectedServiceSheet } from '../SelectedElementDrawer/SelectedServiceSheet'
import { Sheet } from '../Sheet/Sheet'

export function SelectedServiceDrawer() {
  const dispatch = useAppDispatch()

  const selectedService = useAppSelector(timeScheduleSlice.selectors.service)

  if (!selectedService) {
    return null
  }

  return (
    <Sheet
      onOpenChange={(open) => {
        if (open) {
          return
        }

        dispatch(timeScheduleSlice.actions.reset())
      }}
      open
    >
      <SelectedServiceSheet service={selectedService} />
    </Sheet>
  )
}
